const HEADER_FENCE = /^```yaml\r?\n([\s\S]*?)\r?\n```(?:\r?\n|$)/;

function parseYamlBlock(yaml) {
  const header = {};
  for (const line of yaml.split(/\r?\n/)) {
    if (!line.trim() || line.trim().startsWith('#')) continue;
    const idx = line.indexOf(':');
    if (idx === -1) continue;
    header[line.slice(0, idx).trim()] = line.slice(idx + 1).trim();
  }
  return header;
}

export function parseMemoryHeader(text) {
  if (typeof text !== 'string') return { header: null, body: '' };
  const source = text.replace(/^\uFEFF/, '').replace(/^\s+/, '');
  const match = source.match(HEADER_FENCE);
  if (!match) return { header: null, body: source };
  return {
    header: parseYamlBlock(match[1]),
    body: source.slice(match[0].length),
  };
}
